<template>
  <div
    class="emApp is--theme-02"
    :class="{
      'is--mobile': mobile,
    }"
  >
    <header>
      <nav class="header-nav">
        <div class="left-panel">
          <router-link :to="{ name: 'index' }">
            <img src="@/assets/img/logo.png" />
          </router-link>
        </div>
        <div class="right-panel">
          <el-dropdown @command="handleLanguageCommand" v-if="$event.Versions.length > 1 && !$event.Track">
            <div class="link language">
              <el-icon>
                <em-icon-language />
              </el-icon>
              <span>{{ (LANGUAGE[$event.Language] || {}).name }}</span>
            </div>
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item v-for="it in $event.Versions" :key="it.ID" :command="it.ID">{{ (LANGUAGE[it.Language] || {}).name }}</el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
        </div>
      </nav>
    </header>
    <main>
      <section><router-view /></section>
    </main>
  </div>
</template>
<script setup>
  import { useEventListener } from '@vueuse/core'
  import { ref, inject, onMounted, provide } from 'vue'
  import { useRouter } from 'vue-router'
  import { LANGUAGE } from '@/config'
  import { useAppStore } from '@/store/modules/app'
  import { getSteps } from '@/api/config'

  import { storeToRefs } from 'pinia'
  //const mobile = ref(false)

  const development = process.env.NODE_ENV === 'development'
  const appStore = useAppStore()
  const { loadConfig } = appStore
  const { template, mobile } = storeToRefs(appStore)

  const $event = inject('$event')
  const $language = inject('$language')
  const router = useRouter()
  const steps = ref([])
  const resizeBody = () => {
    let width = document.body.getBoundingClientRect().width
    const { setPlatform } = useAppStore()
    setPlatform(width < 1000 ? 'mobile' : 'desktop')
  }

  resizeBody()
  const cleanup = useEventListener('resize', () => {
    resizeBody()
  })

  const handleLanguageCommand = (cmd) => {
    location.href = `./#/checkout?v=${cmd}&_=` + new Date().getTime()
    console.log('handleLanguageCommand', location.href)
    location.reload()
  }

  onMounted(async () => {
    const { data } = await getSteps()
    steps.value = data
  })

  provide('$steps', steps)
</script>

<style lang="scss" scoped>
  .emApp {
    header {
      width: 100%;
      background: #353b55;
      color: #fff;
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      z-index: 2000;
      .header-nav {
        max-width: 1200px;
        margin: 0 auto;
        height: 68px;
        display: flex;
        justify-content: space-between;
        align-items: center;

        padding-left: 12px;
        padding-right: 12px;
        .left-panel {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          img {
            height: 24px;
          }
        }
        .right-panel {
          display: flex;
          justify-content: flex-end;
          align-items: center;
        }
      }
    }
    main {
      width: 100%;
      max-width: 1200px;
      margin: 0 auto;
      padding-top: 68px;
      padding-left: 0;
      padding-right: 0;
      box-sizing: border-box;

      > section {
        padding: 20px;
        margin-top: 0;
      }
    }
    &.is--theme-01 {
      .header-nav {
        max-width: 1000px;
      }
      main {
        max-width: 1000px;
        > section {
          background-color: #fff;
        }
        :deep() {
          .el-card {
            &.box {
              border-color: var(--el-color-primary-light-7);
              border-width: 1px !important;
              box-shadow: none;
              margin-bottom: 20px;
              > .el-card__header {
                padding: 12px 18px;
                background-color: var(--el-color-primary-light-8);
                border-bottom: solid 1px var(--el-color-primary-light-7);
                display: flex;
                justify-content: flex-start;
                align-items: center;
                color: var(--el-color-primary);
                font-size: 14px;
                font-weight: bold;
              }
            }
          }
        }
      }
    }
    &.is--theme-02 {
      .header-nav {
        max-width: 1000px;
      }
      main {
        max-width: 1000px;
        > section {
          padding: 0px 0 0 0;
        }
      }
    }
  }
  @media screen and (max-width: 760px) {
    .emApp {
      header {
        .header-nav {
          justify-content: space-between;
          position: relative;
          padding: 0 12px;
          .left-panel {
            img {
              height: 22px;
            }
          }
        }
      }
      &.is--theme-01 {
        main {
          max-width: calc(100% - 18px);
          > section {
            padding: 0px 0 0 0;
          }
        }
      }
      &.is--theme-02 {
        main {
          max-width: calc(100% - 18px);
          > section {
            padding: 0px 0 0 0;
          }
        }
      }
    }
  }

  .link {
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    > .el-icon {
      font-size: 24px;
      margin-right: 8px;
    }
    > span {
      color: #fff;
      font-size: 14px;
    }
    &.language {
      > .el-icon {
        font-size: 24px;
        margin-right: 4px;
      }
    }
  }
  .el-divider {
    margin: 0 20px;
  }
</style>
